import { useEffect, useState } from "react";

const useMinMaxInput = (initialValue, minValue, maxValue) => {
  const [result, setResult] = useState(initialValue);
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (
      (minValue != undefined && value < minValue) ||
      (maxValue != undefined && value > maxValue)
    ) {
      return;
    } else {
      setResult(value);
    }
  }, [value]);

  const onBlur = () => {
    if (minValue != undefined && value < minValue) {
      setResult(minValue);
      setValue(minValue);
    } else if (maxValue != undefined && value > maxValue) {
      setResult(maxValue);
      setValue(maxValue);
    } else {
      setResult(value);
    }
  };

  return { result, value, setValue, onBlur };
};

export default useMinMaxInput;
